import React from 'react';
import { SectionHeader } from '../ui/SectionHeader';
import { Reveal } from '../ui/Reveal';
import { LinkButton } from '../ui/Button';
import { processSteps } from '../../data/services';
export function HowItWorks() {
  return <section className="bg-cream py-20 lg:py-32" data-id="element-213" data-mp="2sysbsyjb3dy">
      <div className="mx-auto max-w-shell px-5 lg:px-10" data-id="element-214" data-mp="3tyi6d2o0jeqm">
        <SectionHeader eyebrow="¿Cómo funciona?" title="Simple, claro y personalizado." data-id="element-215" data-mp="3twxbfbxsdts8" />

        <ol className="relative mt-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-216" data-mp="bqsql9fv073r">
          {processSteps.map((s, i) => <li key={s.n} className="relative" data-id="element-217" data-mp="lj85tyzruhky" data-mpi={i}>
              <Reveal delay={i * 0.07} data-id="element-218" data-mp="lhx1ny2ez7tb">
                <div className="flex items-center gap-4" data-id="element-219" data-mp="gjvkxjsgnkl0">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-teal/25 bg-white font-display text-[12px] font-semibold text-teal" data-id="element-220" data-mp="gkdn0x1t0t0u">
                    {s.n}
                  </span>
                  <span className="h-px flex-1 bg-navy/10" data-id="element-221" data-mp="24c7hl1v73vhn" />
                </div>
                <h3 className="mt-5 font-display text-[14px] font-semibold tracking-[0.12em] text-navy" data-id="element-222" data-mp="24ek4zujq2y23">
                  {s.title}
                </h3>
                <p className="mt-3 text-[13.5px] font-light leading-relaxed text-ink/65" data-id="element-223" data-mp="2dbuf3ckt0h5f">
                  {s.text}
                </p>
              </Reveal>
            </li>)}
        </ol>

        <Reveal className="mt-14" data-id="element-224" data-mp="2na0ennj51b74">
          <LinkButton href="#agenda" size="lg" className="w-full sm:w-auto" data-id="element-225" data-mp="2n8z4rmduyuqz">
            AGENDA TU CONVERSACIÓN
          </LinkButton>
        </Reveal>
      </div>
    </section>;
}